import { ChangeDetectionStrategy, ViewEncapsulation, Component, input, computed } from '@angular/core';

@Component({
    selector: 'fi-todo-list-progress',
    templateUrl: './todo-list-progress.component.html',
    styleUrl: './todo-list-progress.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-todo-list-progress' },
    standalone: false,
})
export class FiTodoListProgressComponent {
    public totalTodoItemsCount = input.required<number>();
    public completedTodoItemsCount = input.required<number>();

    protected progressValue = computed(() =>
        Math.round((this.completedTodoItemsCount() / this.totalTodoItemsCount()) * 100),
    );
    protected notCompletedTodoItemsCount = computed(() => this.totalTodoItemsCount() - this.completedTodoItemsCount());
}
